import {
    Component,
    OnInit,
    Output,
    ViewChild,
    EventEmitter,
    Input,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SimyoService } from '../../services/simyo.service';
import {
    masterAllSimyo,
    serviceProviderSimyo,
} from '../../models/masterAllSimyo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { orderType } from 'src/app/shared/constantes';

@Component({
    selector: 'app-simyo-modal-portability',
    templateUrl: './simyo-modal-portability.component.html',
    styleUrls: ['./simyo-modal-portability.component.css', '../../../../assets/css/simyo-theme.css'],
    standalone: false
})
export class SimyoModalPortabilityComponent implements OnInit {
    @ViewChild('portabilityModal') portabilityModal: any;
    @Input() typeOrder = null;

    @Output() onAnswer = new EventEmitter<{ answer: string, portabilityOperator: any, offerSelected: any }>();

    private allSubscription: Subscription[] = [];
    public serviceProviders: serviceProviderSimyo[] = [];
    portabilityForm!: FormGroup;

    showOperators = false;
    selected = false;
    showOperatorError: boolean = false;
    showCommitmentContract: boolean = false;
    offerSelected: '12' | '3' | null = null;
    isHovered12: boolean = false;
    isHovered3: boolean = false;
    onlyOneProvider: boolean = false;

    public orderType = orderType;

    constructor(
        private modalService: NgbModal,
        public simyoService: SimyoService,
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {
        this.portabilityForm = this.fb.group({
            portability_operator: ['', Validators.required],
            commitment_option: [null]
        });

        this.portabilityForm.get('portability_operator')?.valueChanges.subscribe((value) => {
            if ((value?.value != null && value?.value !== 'Otros') && this.typeOrder !== orderType.MOBILE) {
                this.showCommitmentContract = true;
                this.portabilityForm.get('commitment_option')?.setValidators(Validators.required);
            } else {
                this.showCommitmentContract = false;
                this.portabilityForm.get('commitment_option')?.clearValidators();
                this.portabilityForm.get('commitment_option')?.setValue(null);
            }
            this.portabilityForm.get('commitment_option')?.updateValueAndValidity();
        });

        this.allSubscription.push(
            this.simyoService
                .getMasterAll()
                .subscribe((data: masterAllSimyo) => {
                    if (data) {
                        this.serviceProviders = data.service_providers;
                        this.serviceProviders = data.service_providers.filter(
                            (provider: any) => this.simyoService.excludeProviders.includes(provider.service_provider_id)
                        );
                        this.onlyOneProvider = this.serviceProviders.length === 1;
                        let otros = { service_provider_id: 0, value: "Otros" }
                        this.serviceProviders.push(otros);
                    }
                })
        );
    }

    showProviders() {
        this.selected = true;
        if (this.onlyOneProvider) {
            this.portabilityForm.get('portability_operator')?.setValue(this.serviceProviders[0]);
        }
        this.showOperators = true;
    }

    open() {
        let modalPortability = this.modalService.open(this.portabilityModal, {
            size: 'lg',
            centered: true,
            windowClass: 'portability-modal',
        });

        modalPortability.result.then(
            (result) => { },
            (reason) => {
                if (reason === 0) {
                    this.showOperators = false;
                    this.selected = false;
                }
            }
        );
    }

    respond(answer: string, modal: any) {
        this.simyoService.setSelectedOperator(null);
        const selectedOperator = this.portabilityForm.get('portability_operator')?.value;
        const offerSelected = this.typeOrder !== orderType.MOBILE ? this.portabilityForm.get('commitment_option')?.value : ( selectedOperator?.service_provider_id == 0 ? this.portabilityForm.get('commitment_option')?.value : '12');

        if (answer === 'accept') {
            this.simyoService.setOptionSelectedModalPorta(true); // Guardar la opción seleccionada en el modal (SI PORTABILIDAD)
            if (this.portabilityForm.invalid) {
                this.portabilityForm.markAllAsTouched();
                return;
            }

            if (selectedOperator?.service_provider_id == 0 || (this.typeOrder !== orderType.MOBILE && selectedOperator?.service_provider_id !== 0 && offerSelected === '3')) {
                answer = 'cancel';
            }

            this.simyoService.setSelectedOperator(selectedOperator);
            this.onModalDismiss(modal);
            let selectedOperatorValue = selectedOperator.value;
            selectedOperator.value = 'antidigi';
            this.onAnswer.emit({ answer, portabilityOperator: selectedOperator, offerSelected: offerSelected });
            selectedOperator.value = selectedOperatorValue;
        } else {
            this.simyoService.setOptionSelectedModalPorta(false); // Guardar la opción seleccionada en el modal (NO PORTABILIDAD)
            this.onModalDismiss(modal);
            this.onAnswer.emit({ answer, portabilityOperator: null, offerSelected: null });
        }
    }

    onModalDismiss(modal: any, closeBtn: boolean = false) {
        if (closeBtn) {
            this.selected = false;
            this.showOperators = false;
            this.portabilityForm.reset();
        }
        this.showOperators = false;
        this.selected = false;
        modal.dismiss('Cross click');
    }

    selectOffer(value: '12' | '3'): void {
        this.portabilityForm.get('commitment_option')?.setValue(value);
    }
}
